/** One responsive product module: moving it preserves form IDs and cart state. */
class OutdoorBengalEditorial extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.mobile = matchMedia('(max-width: 749px)');
    this.placeProducts = () => {
      const products = this.querySelector('[data-ob-products]');
      const target = this.mobile.matches
        ? this.querySelector('[data-ob-product-slot]') || this.querySelector('[data-ob-product-home]')
        : this.querySelector('[data-ob-product-home]');
      if (products && target && products.parentElement !== target) target.append(products);
    };
    this.mobile.addEventListener('change', this.placeProducts, { signal });
    this.placeProducts();
    if (this.dataset.tracking !== 'true' || window.Shopify?.designMode) return;
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('a, button[name="add"]');
      const module = link?.closest('[data-ob-module]');
      if (!link || !module || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
      const href = link.href || link.closest('product-card')?.querySelector('a')?.href;
      const destination = href ? new URL(href, location.origin).pathname : '';
      const payload = {
        page_type: this.dataset.pageType,
        blog_handle: this.dataset.blog,
        article_id: this.dataset.articleId || '',
        module_name: module.dataset.obModule,
        item_id: link.closest('[data-ob-item]')?.dataset.obItem || '',
        destination_path: destination,
        action: link.matches('button') ? 'product_cta' : 'navigate',
      };
      // Shopify custom pixels may subscribe to this event. No identifiers or query strings.
      window.Shopify?.analytics?.publish?.('ob_editorial_click', payload);
    }, { signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('ob-editorial')) customElements.define('ob-editorial', OutdoorBengalEditorial);
